:root {
	--bg: #f7f8fb;
	--card: #ffffff;
	--muted: #667085;
	--text: #111827;
	--border: #e5e7eb;
	--primary: #7fb02f;
	--primary-light: rgba(127, 176, 47, 0.15);
	--primary-border: rgba(127, 176, 47, 0.35);
	--ring: #7fb02f;
}

*,
*::before,
*::after {
	box-sizing: border-box;
}

.container {
	width: 100%;
	margin: 0 auto;
	padding: 8px;
	color: var(--text);
	background: transparent;
}

.header {
	display: flex;
	align-items: center;
	gap: 6px;
	margin-bottom: 8px;
}

.title {
	font-size: 16px;
	font-weight: 700;
}

.badge {
	margin-left: 4px;
	padding: 1px 6px;
	font-size: 11px;
	color: var(--text);
	background: var(--primary-light);
	border: 1px solid var(--primary-border);
	border-radius: 999px;
}

.toolbar {
	display: flex;
	gap: 6px;
	margin-bottom: 8px;
}

.btn {
	border: 1px solid var(--border);
	background: var(--card);
	color: var(--primary-color);
	height: 28px;
	padding: 0 8px;
	border-radius: 6px;
	font-size: 12px;
	font-weight: 600;
	line-height: 1;
	cursor: pointer;
	transition:
		background 0.12s ease,
		border-color 0.12s ease;

	&:hover {
		background: rgba(255, 255, 255, 0.03);
	}
	&:disabled {
		opacity: 0.55;
		cursor: not-allowed;
	}
}

.groups {
	display: grid;
	gap: 6px;
	grid-template-columns: repeat(2, minmax(0, 1fr));
}

.group {
	background: var(--card);
	border: 1px solid var(--border);
	border-radius: 6px;
}

.groupHeader {
	width: 100%;
	display: grid;
	grid-template-columns: 1fr auto auto;
	align-items: center;
	gap: 6px;
	padding: 6px 8px;
	background: transparent;
	border: 0;
	cursor: pointer;
	text-align: left;
	font-size: 13px;

	&:hover {
		background: rgba(127, 176, 47, 0.05);
	}
}

.groupTitle {
	font-weight: 700;
	font-size: 13px;
	color: var(--primary-color);
}

.count {
	justify-self: end;
	font-size: 11px;
	color: var(--muted);
	border-radius: 999px;
	padding: 1px 6px;
	border: 1px solid var(--border);
}

.chevron {
	justify-self: end;
	font-size: 13px;
	color: var(--muted);
}

.list {
	margin: 0;
	padding: 4px;
	list-style: none;
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 4px;

	@media (min-width: 640px) {
		grid-template-columns: repeat(3, minmax(0, 1fr));
	}
	@media (min-width: 960px) {
		grid-template-columns: repeat(4, minmax(0, 1fr));
	}
	@media (min-width: 1280px) {
		grid-template-columns: repeat(6, minmax(0, 1fr));
	}
}

.item {
	border: 1px solid var(--border);
	background: var(--card);
	border-radius: 6px;
	padding: 4px 6px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	min-height: 26px;
	font-size: 12px;
	color: var(--text);
}

.itemName {
	font-size: 12px;
	color: var(--text);
}

.skeleton {
	padding: 8px;
	border: 1px dashed var(--border);
	border-radius: 6px;
	color: var(--muted);
	background: var(--card);
}
